export const KEYBOARD_KEYS_MAPPING: Record<string, number> = {
  plus: 187,
  minus: 189,
  delete: 46,
  backspace: 8,
  space: 32,
  z: 90,
  c: 67,
  v: 86
}
